import { Section } from '@/store/section.interface';
import { Context } from '@/store/context.interface';
import { LanguageTranslation } from "@/store/language.interface";
import { StoredFile } from './common.interface';
import { HomepageItem } from './homepageItem.interface';
import { constant } from '@/constant';

export interface DTOConsultation {
    id: number;
    slug: string;
    begin_date: string;
    end_date: string;
    created_at: string;
    updated_at: string;
    status: number;
    type: number;
    community_id: number;
    order_num: number;
    banner_file: StoredFile;
    title: LanguageTranslation;
    description: LanguageTranslation;
    summary: ConsultationSummary;
    welcome_video: LanguageTranslation | null;
    private_email_allowed: PrivateAllowed | null;
    options: any;
    attachmentsOpened: boolean | null;
    projects: ConsultationProject[];
    subscriber_mailing_list: ConsultationSubscriberMailingList | null;
}

export interface Consultation extends HomepageItem {
    id: number;
    createdAt: string;
    updatedAt: string;
    communityId: number;
    orderNum: number;
    section: Section[];
    context: Context[];
    summary: ConsultationSummary;
    welcomeVideo: LanguageTranslation | null;
    privateEmailAllowed: PrivateAllowed | null;
    options: any;
    attachmentsOpened: boolean | null;
    slug: string;
    projects: ConsultationProject[];
    subscriberMailingList: ConsultationSubscriberMailingList | null;
}

export interface ConsultationProject {
    id: number;
    title: LanguageTranslation;
}

interface PrivateAllowed {
    email: [];
    domain: [];
}

interface ConsultationSummary {
    sections?: number;
    polls: number;
    surveys: number;
    votes: number;
    user_participation?: number;
}

interface ConsultationSubscriberMailingList {
    isUserSubscribed: boolean;
    subscriberCount: number;
}

export function parseConsultation(consultationDto: DTOConsultation): Consultation {
    return {
        itemType: constant.HomePageItem.Type.Consultation,
        id: consultationDto.id,
        slug: consultationDto.slug,
        status: consultationDto.status,
        beginDate: consultationDto.begin_date ? new Date(consultationDto.begin_date) : null,
        endDate: consultationDto.end_date ? new Date(consultationDto.end_date) : null,
        type: consultationDto.type,
        communityId: consultationDto.community_id,
        bannerFile: consultationDto.banner_file,
        orderNum: consultationDto.order_num,
        title: consultationDto.title,
        description: consultationDto.description,
        summary: consultationDto.summary,
        section: [],
        context: [],
        createdAt: consultationDto.created_at,
        updatedAt: consultationDto.updated_at,
        welcomeVideo: consultationDto.welcome_video,
        privateEmailAllowed: consultationDto.private_email_allowed,
        options: consultationDto.options,
        attachmentsOpened: consultationDto.attachmentsOpened,
        projects: consultationDto.projects,
        subscriberMailingList: consultationDto.subscriber_mailing_list
    };
}